import { render, staticRenderFns } from "./OncontextMenu.vue?vue&type=template&id=190b3206&scoped=true"
import script from "./OncontextMenu.vue?vue&type=script&lang=js"
export * from "./OncontextMenu.vue?vue&type=script&lang=js"
import style0 from "./OncontextMenu.vue?vue&type=style&index=0&id=190b3206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b3206",
  null
  
)

export default component.exports